module.exports = {"id":"213582","name":"Alan Ruiz","rating":"77","photo":"./data/images/photos/0/213582.png","club":{"name":"Santa Fe","logo":"./data/images/clubs/SantaFe.png"},"positions":["BU","ATT","MOC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlanRuiz0.json
// module id = 153
// module chunks = 0